import React, { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "../../../ui/input";
import ScreenCard from "../../../ui/DashbordActiveScreensCard";
import ItemListPopup from "../../../ui/ItemListPopup";
import FilterDrawerContent from "./filters/FilterDrawerContent";
import { ReactComponent as Filter } from "../../../../assets/icons/svg/filter-icon.svg";

const ActiveScreens = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [searchCity, setSearchCity] = useState("");
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [selectedCities, setSelectedCities] = useState<string[]>([]);

  const screens = [
    {
      id: "1",
      image:
        "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=200&h=150&fit=crop&crop=center",
      title: "BLR/Screen 3",
      creatives: 24,
      tags: ["Bangalore", "Table", "Screen 3", "Landscape"],
    },
    {
      id: "2",
      image:
        "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=200&h=150&fit=crop&crop=center",
      title: "Mumbai/Screen 1",
      creatives: 18,
      tags: ["Mumbai", "Main door", "Screen 1", "Portrait"],
    },
    {
      id: "3",
      image:
        "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=200&h=150&fit=crop&crop=center",
      title: "Delhi/Screen 2",
      creatives: 32,
      tags: ["Delhi", "table", "Screen 2", "Landscape"],
    },
  ];

  const tagCategories = {
    Screen: ["Screen 1", "Screen 2", "Screen 3"],
    Orientation: ["Landscape", "Portrait", "Square"],
    Location: ["Main door", "Table", "Modern"],
    City: ["Bangalore", "Mumbai", "Delhi"],
  };

  const handleClearAll = () => {
    setSelectedTags([]);
  };

  const handleApply = () => {
    setIsFilterOpen(false);
  };

  const handleCancel = () => {
    setIsFilterOpen(false);
  };

  const toggleCitySelection = (city: string) => {
    setSelectedCities((prev) =>
      prev.includes(city) ? prev.filter((c) => c !== city) : [...prev, city]
    );
  };

  const filteredCities = tagCategories.City.filter((city) =>
    city.toLowerCase().includes(searchCity.toLowerCase())
  );

  const filteredScreens = screens.filter((screen) => {
    const tagMatch =
      selectedTags.length === 0 ||
      selectedTags.some((tag) => screen.tags.includes(tag));

    const cityMatch =
      selectedCities.length === 0 ||
      selectedCities.some((city) => screen.tags.includes(city));

    return tagMatch && cityMatch;
  });

  return (
    <div className="w-full max-w-screen-full mx-auto px-4 py-3 flex flex-col gap-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-sm md:text-base xl:text-lg 2xl:text-xl 3xl:text-2xl whitespace-nowrap">
          Active screens
        </h2>

        <div className="flex flex-wrap items-center gap-4">
          {/* Search screen input */}
          <div className="relative">
            <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
              <Search className="w-4 h-4  3xl:w-6 3xl:h-6 text-[#808191] " />
            </div>
            <Input
              placeholder="Search content"
              className="pl-10 pr-2 3xl:pl-12 text-sm font-medium text-[#808191] rounded-[8px] placeholder:text-left
                w-[160px] md:w-[160px] xl:w-[200px] 2xl:w-[230px] 3xl:w-[250px]
                h-[32px] md:h-[32px] xl:h-[42px] 2xl:h-[46px] 3xl:h-[52px]"
            />
          </div>

          {/* City Search Dropdown */}
          <div className="relative w-[160px] md:w-[160px] xl:w-[200px] 2xl:w-[230px] 3xl:w-[250px]">
            <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
              <Search className="w-4 h-4  3xl:w-6 3xl:h-6 text-[#808191]" />
            </div>
            <Input
              value={searchCity}
              onChange={(e) => {
                setSearchCity(e.target.value);
                setShowCityDropdown(true);
              }}
              onFocus={() => setShowCityDropdown(true)}
              onBlur={() => setTimeout(() => setShowCityDropdown(false), 150)}
              placeholder="Search Screens"
              className="pl-10 pr-2 3xl:pl-12 text-sm font-medium text-[#808191] rounded-[8px] placeholder:text-left
               
                h-[32px] md:h-[32px] xl:h-[42px] 2xl:h-[46px] 3xl:h-[52px]"
            />
            {showCityDropdown && filteredCities.length > 0 && (
              <div className="absolute z-10 mt-1 p-2 w-full bg-white border rounded-[8px] shadow">
                {filteredCities.map((city) => (
                  <label
                    key={city}
                    className={`flex items-center gap-3 mb-1 px-5 py-2 cursor-pointer rounded-[10px] hover:bg-blue-50 ${
                      selectedCities.includes(city) ? "bg-[#EFFCFF]" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedCities.includes(city)}
                      onChange={() => toggleCitySelection(city)}
                      className="accent-[#0091AF] rounded-[2px]"
                    />
                    {city}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* Filter button */}
          <button
            onClick={() => setIsFilterOpen(true)}
            className="rounded-[10px] text-blue-500 flex items-center justify-center
              w-[32px] h-[32px] md:w-[32px] md:h-[32px]
              xl:w-[42px] xl:h-[42px]
              lg:w-[46px] lg:h-[46px]
              2xl:w-[46px] 2xl:h-[46px]
              3xl:w-[52px] 3xl:h-[52px] hover:bg-blue-50 transition-colors duration-200"
            style={{ borderWidth: "0.5px", borderColor: "#0091AF" }}
          >
            <Filter className="w-5 h-5 lg:w-6 lg:h-6" />
          </button>
        </div>
      </div>

      <div className="min-h-screen bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full items-start">
          {filteredScreens.map((screen) => (
            <div key={screen.id} className="relative">
              <ScreenCard screen={screen} />
            </div>
          ))}
        </div>
      </div>

      {/* Slide-in Filter Drawer */}
      {isFilterOpen && (
        <ItemListPopup title="Filter" onClose={handleCancel}>
          <FilterDrawerContent
            selectedTags={selectedTags}
            setSelectedTags={setSelectedTags}
            onClearAll={handleClearAll}
            onApply={handleApply}
            onCancel={handleCancel}
            categories={tagCategories}
          />
        </ItemListPopup>
      )}
    </div>
  );
};

export default ActiveScreens;
